import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appOnlyLetters]'
})
export class OnlyLettersDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('blur') onBlur() {
    const control = this.ngControl.control;
    const value = control?.value;

    if (typeof value === 'string' && value) {
      control.patchValue(this.normalizeValue(value));
    }
  }

  private normalizeValue(value: string): string {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z- ]/g, '')
      .trim();
  }
}
